import { configureStore } from '@reduxjs/toolkit';
import voucherAuthReducer from './slices/voucherAuthSlice';
import countdownReducer from './slices/countdownSlice';
import vooksCountdownReducer from './slices/vooksCountdownSlice';
import { getCookie, setCookie } from '../utils/cookieUtils';

const reducer = {
  voucherAuth: voucherAuthReducer,
  countdown: countdownReducer,
  vooksCountdown: vooksCountdownReducer,
};

// 최초 cookie에 키 밸류가 있다면 persistedState에 저장한다.
const preloadedState = {
  voucherAuth: getCookie('voucherAuth') ? getCookie('voucherAuth') : {},
  countdown: getCookie('countdown')?.count !== undefined ? getCookie('countdown') : undefined,
  vooksCountdown: getCookie('vooksCountdown') ? getCookie('vooksCountdown') : {},
};

const store = configureStore({
  reducer,
  preloadedState,
});

// dispatch가 일어날 때마다 작동하는 subscribe 함수를 넣어, 현재 상태를 읽기 위해 getState() 추가해 준다.
store.subscribe(() => {
  const expires = new Date();
  expires.setDate(expires.getDate() + 10);
  setCookie('voucherAuth', store.getState().voucherAuth, { path: '/', expires });
  setCookie('countdown', store.getState().countdown, { path: '/', expires });
  setCookie('vooksCountdown', store.getState().vooksCountdown, { path: '/', expires });
});

export default store;
